@let texts = textStore.texts();

<aw-dialog
  (onClose)="dialogRef.close($event); instituteDataStore.reload()"
  [content]="content"
  [footer]="footer"
  [width]="width"
  [data]="data"
  [title]="
    texts
      | filterTexts: ERelationType.headline : EEntityType.subscription
      | language
  ">
  <ng-template #content>
    <div class="flex flex-row flex-wrap gap-4" [formGroup]="bankDataForm">
      <div class="flex w-full flex-row gap-4">
        <aw-text-input
          id="first-name"
          [label]="
            texts
              | filterTexts: ERelationType.firstName : EEntityType.subscription
              | language
          "
          formControlName="firstName"></aw-text-input>
        <aw-text-input
          id="last-name"
          [label]="
            texts
              | filterTexts: ERelationType.lastName : EEntityType.subscription
              | language
          "
          formControlName="lastName"></aw-text-input>
      </div>
      <aw-text-input
        id="iban"
        [label]="
          texts
            | filterTexts: ERelationType.iban : EEntityType.subscription
            | language
        "
        formControlName="iban"></aw-text-input>
      <aw-text-input
        id="bic"
        [label]="
          texts
            | filterTexts: ERelationType.bic : EEntityType.subscription
            | language
        "
        formControlName="bic"></aw-text-input>
      <aw-text-input
        id="credit-institute"
        [label]="
          texts
            | filterTexts
              : ERelationType.creditInstitute
              : EEntityType.subscription
            | language
        "
        formControlName="creditInstitute"></aw-text-input>
      <aw-checkbox
        id="sepa-agreement"
        [label]="
          texts
            | filterTexts
              : ERelationType.sepaAgreement
              : EEntityType.subscription
            | language
            | templateString
              : {
                  shopOwner:
                    (texts
                    | filterTexts: ERelationType.client : EEntityType.generic
                    | language),
                }
        "
        formControlName="sepaAgreement"></aw-checkbox>
    </div>
  </ng-template>
  <ng-template #footer>
    <aw-button
      [id]="'confirm'"
      [type]="'button'"
      [isDisabled]="!bankDataForm.valid"
      (click)="saveChanges()"
      [text]="
        texts | filterTexts: ERelationType.save : EEntityType.generic | language
      "
      class="mr-3 w-full" />
    <aw-button
      class="w-full"
      [id]="'cancel'"
      [type]="'button'"
      (click)="dialogRef.close()"
      [style]="'primary-alt'"
      [text]="
        texts
          | filterTexts: ERelationType.cancel : EEntityType.generic
          | language
      " />
  </ng-template>
</aw-dialog>
